import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "fileDisplay", "selectedFile", "fileName", "fileSize"]

  connect() {
    // Initialize if there's already a file selected
    if (this.hasFileInputTarget && this.fileInputTarget.files.length > 0) {
      this.handleFileSelect({ target: this.fileInputTarget })
    }
  }

  handleFileSelect(event) {
    const file = event.target.files[0]

    if (file && file.type === 'application/pdf') {
      this.showSelectedFile(file)
    }
  }

  showSelectedFile(file) {
    if (this.hasFileDisplayTarget) {
      this.fileDisplayTarget.classList.add('hidden')
    }

    if (this.hasSelectedFileTarget) {
      this.selectedFileTarget.classList.remove('hidden')
    }

    if (this.hasFileNameTarget) {
      this.fileNameTarget.textContent = file.name
    }

    if (this.hasFileSizeTarget) {
      this.fileSizeTarget.textContent = this.formatFileSize(file.size)
    }
  }

  changeFile(event) {
    event.preventDefault()

    if (this.hasSelectedFileTarget) {
      this.selectedFileTarget.classList.add('hidden')
    }

    if (this.hasFileDisplayTarget) {
      this.fileDisplayTarget.classList.remove('hidden')
    }

    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = ''
      this.fileInputTarget.click()
    }
  }

  formatFileSize(bytes) {
    if (bytes < 1024) return bytes + ' bytes'
    else if (bytes < 1048576) return Math.round(bytes / 1024) + ' KB'
    else return Math.round(bytes / 1048576) + ' MB'
  }
}
